import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { apiClient } from '@/apis/instances/api-client'
import { checkApiResponse } from '@/apis/instances/check-api-response'
import { MutationComposableParams } from '@/types/query-options'
import { resolveMaybeGetter } from '@/util/resolve-maybe-getter'
import { v2ReservationUserNoteKeys } from './use-v2-reservationusernote-find-query'
import { v2ReservationUserNoteDateKeys } from './use-v2-reservationusernote-find-date-query'

type UpdateReservationUserNoteBody = Parameters<typeof apiClient.v2.apiV2ReservationusernoteElUpdate>[0]

const updateReservationUserNote = async (body: UpdateReservationUserNoteBody) => {
  const { data } = await apiClient.v2.apiV2ReservationusernoteElUpdate(body)
  return checkApiResponse(data)
}

export const useV2ReservationUserNoteUpdateMutation = ({ options }: MutationComposableParams<unknown, UpdateReservationUserNoteBody> = {}) => {
  const queryClient = useQueryClient()
  return useMutation(() => {
    const resolved = resolveMaybeGetter(options ?? {})
    return {
      mutationFn: updateReservationUserNote,
      ...resolved,
      // 저장 성공 시 도메인 캐시를 무효화한다 — 다음 조회가 fresh 데이터를 가져온다
      onSuccess: (data, variables, context) => {
        queryClient.invalidateQueries({ queryKey: v2ReservationUserNoteKeys.all })
        queryClient.invalidateQueries({ queryKey: v2ReservationUserNoteDateKeys.all })
        return (resolved as { onSuccess?: (...args: unknown[]) => unknown }).onSuccess?.(data, variables, context)
      },
    }
  })
}
